import { withStyles } from '@mui/styles';
import React, { PureComponent } from 'react';
import { IconSearch } from 'jitsi/base/icons/svg';
import Icon from 'jitsi/base/icons/components/Icon';
import Input from 'jitsi/base/ui/components/web/Input';
import { translate } from 'jitsi/base/i18n/functions';
import cx from 'clsx';
class QuickRepliesDialog extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            expandedCategories: {},
        };
    }
    toggleCategory(catId) {
        this.setState((prev) => {
            const current = prev.expandedCategories[catId] !== false; // Default is true
            return {
                expandedCategories: {
                    ...prev.expandedCategories,
                    [catId]: !current,
                },
            };
        });
    }
    render() {
        const { categories, onSelect, classes, t } = this.props;
        const { search, expandedCategories } = this.state;
        const lowSearch = search.toLowerCase();
        const filteredCategories = (categories || []).map(cat => {
            const messages = cat.quick_reply_messages || cat.quickReplyMessages || [];
            const matchesCategory = (cat.name && cat.name.toLowerCase().includes(lowSearch));
            const filteredMessages = messages.filter(msg => msg.content.toLowerCase().includes(lowSearch));
            if (matchesCategory || filteredMessages.length > 0) {
                return {
                    ...cat,
                    quick_reply_messages: matchesCategory ? messages : filteredMessages
                };
            }
            return null;
        }).filter(Boolean);
        return (React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.header },
                React.createElement("div", { className: classes.title }, t('chat.quickReplies') || 'Quick Replies'),
                React.createElement("div", { className: classes.description }, t('chat.quickRepliesDescription') || 'You can quickly send it by clicking on the message')),
            React.createElement("div", { className: classes.searchContainer },
                React.createElement(Input, { autoFocus: true, id: 'quick-reply-search', className: classes.searchInput, onChange: (val) => this.setState({ search: val }), placeholder: t('chat.search'), value: search }),
                React.createElement(Icon, { src: IconSearch, size: 16, className: classes.searchIcon })),
            React.createElement("div", { className: classes.list }, filteredCategories.length === 0 ? (React.createElement("div", { className: classes.emptyState }, t('chat.noResults'))) : (filteredCategories.map((cat) => {
                const isExpanded = expandedCategories[cat.id] !== false;
                return (React.createElement("div", { key: cat.id, className: classes.category },
                    React.createElement("div", { className: cx(classes.categoryHeader, { [classes.expanded]: isExpanded }), onClick: () => this.toggleCategory(cat.id) },
                        React.createElement("span", null, cat.name),
                        React.createElement("svg", { className: cx(classes.accordionIcon, { [classes.expandedIcon]: isExpanded }), width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("path", { d: "M12 10L8 6L4 10", stroke: "#717182", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }))),
                    isExpanded && (React.createElement("div", { className: classes.messageList }, (() => {
                        const messages = cat.quick_reply_messages || cat.quickReplyMessages || [];
                        return messages.length > 0 ? (messages.map((msg) => (React.createElement("div", { key: msg.id, className: classes.messageItem, onClick: () => onSelect(msg.content) },
                            React.createElement("div", { className: classes.sendIcon, onClick: (e) => {
                                    e.stopPropagation();
                                    onSelect(msg.content, true);
                                } },
                                React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                    React.createElement("path", { d: "M9.6907 14.4577C9.71603 14.5208 9.76006 14.5747 9.81688 14.6121C9.87371 14.6494 9.9406 14.6685 10.0086 14.6668C10.0766 14.665 10.1424 14.6426 10.1973 14.6023C10.2521 14.5621 10.2933 14.506 10.3154 14.4417L14.6487 1.77503C14.67 1.71596 14.6741 1.65203 14.6604 1.59073C14.6468 1.52943 14.6159 1.47329 14.5715 1.42888C14.5271 1.38447 14.471 1.35363 14.4097 1.33996C14.3484 1.32629 14.2844 1.33036 14.2254 1.3517L1.5587 5.68503C1.49436 5.70709 1.43832 5.74831 1.39808 5.80314C1.35785 5.85798 1.33535 5.92381 1.33361 5.9918C1.33186 6.05979 1.35096 6.12669 1.38834 6.18351C1.42571 6.24034 1.47958 6.28437 1.5427 6.3097L6.82937 8.4297C6.99649 8.49661 7.14833 8.59667 7.27574 8.72385C7.40315 8.85103 7.50349 9.00269 7.5707 9.1697L9.6907 14.4577Z", stroke: "#4DA648", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }),
                                    React.createElement("path", { d: "M14.5692 1.43164L7.27588 8.72431", stroke: "#4DA648", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }))),
                            React.createElement("span", null, msg.content))))) : (React.createElement("div", { className: classes.emptyCategory }, t('chat.noMessages')));
                    })()))));
            })))));
    }
}
const styles = (theme) => ({
    root: {
        position: 'absolute',
        bottom: '100%',
        left: 0,
        width: '358px',
        maxHeight: '480px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.iisightWhiteBackground,
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        fontFamily: '"Nunito Sans"',
        zIndex: 10,
        marginBottom: theme.spacing(1.5),
    },
    header: {
        display: 'flex',
        width: '358px',
        height: '74px',
        padding: '12px 16px 1px 16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '2px',
        borderBottom: '1px solid rgba(217, 217, 217, 0.50)',
    },
    title: {
        fontWeight: 700,
        fontSize: '18px',
        color: '#202020',
        lineHeight: '28px',
        margin: 0,
        fontFamily: '"Nunito Sans"',
    },
    description: {
        fontSize: '12px',
        fontWeight: 400,
        color: '#6F6F6F',
        marginTop: '2px',
        lineHeight: '18px',
        fontFamily: '"Nunito Sans"',
    },
    searchContainer: {
        display: 'flex',
        padding: '12px 16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        alignSelf: 'stretch',
        borderBottom: '1px solid rgba(217, 217, 217, 0.50)',
        position: 'relative',
    },
    searchInput: {
        width: '100%',
        '& input': {
            height: '40px',
            borderRadius: '10px !important',
            backgroundColor: `${theme.palette.iisightGray100} !important`,
            padding: '10px 36px 10px 12px !important',
            fontSize: '14px',
            color: '#202020 !important',
            border: 'none !important',
            fontFamily: '"Nunito Sans"',
            '&::placeholder': {
                color: '#bbb !important',
                opacity: 1,
            }
        }
    },
    searchIcon: {
        position: 'absolute',
        right: '28px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg, & path': {
        // fill removed here, will be handled by JSX color
        }
    },
    accordionIcon: {
        width: '16px',
        height: '16px',
        transition: 'transform 0.2s',
        transform: 'rotate(180deg)',
    },
    expandedIcon: {
        transform: 'rotate(0deg)',
    },
    list: {
        overflowY: 'auto',
        flex: 1,
    },
    category: {
        borderBottom: `1px solid ${theme.palette.iisightGray100}`,
    },
    categoryHeader: {
        display: 'flex',
        padding: '12px 32px 11.5px 16px',
        alignItems: 'flex-start',
        gap: '149px',
        alignSelf: 'stretch',
        backgroundColor: '#F6F6F6',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        userSelect: 'none',
        '&:hover': {
            backgroundColor: '#f1f1f1',
        },
        '& span': {
            fontWeight: 700,
            fontSize: '14px',
            color: '#202020',
            lineHeight: '20px',
            fontFamily: '"Nunito Sans"',
            flex: 1,
        },
    },
    messageList: {
        padding: 0,
        backgroundColor: '#fff',
    },
    messageItem: {
        display: 'flex',
        padding: '12px 59.164px 12px 16px',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '& span': {
            fontSize: '14px',
            fontWeight: 600,
            color: '#4B4B4B',
            lineHeight: '20px',
            fontFamily: '"Nunito Sans"',
        },
        '&:hover': {
            backgroundColor: '#F1F8F0',
        },
        '&:hover $sendIcon': {
            visibility: 'visible',
        }
    },
    sendIcon: {
        visibility: 'hidden',
        width: '16px',
        height: '16px',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            width: '16px',
            height: '16px',
        }
    },
    emptyState: {
        padding: '24px 16px',
        textAlign: 'center',
        color: '#999',
        fontSize: '13px',
        fontFamily: '"Nunito Sans"',
    },
    emptyCategory: {
        padding: '12px 16px',
        fontSize: '13px',
        color: '#999',
        fontStyle: 'italic',
        fontFamily: '"Nunito Sans"',
    },
});
export default withStyles(styles)(translate(QuickRepliesDialog));
